import { apiRequest } from "../services/apiUtils";

/**
 * 省份信息接口
 */
export interface Province {
  id: number;
  name: string;
}

/**
 * 城市信息接口
 */
export interface City {
  id: number;
  name: string;
  provinceId: number;
}

/**
 * 地区服务类
 */
class RegionsService {
  /**
   * 获取所有省份列表
   */
  async getProvinces(): Promise<Province[]> {
    const response = await apiRequest<{ data: Province[] }>(
      "/api/v1/regions/provinces",
      "GET"
    );
    return response.data;
  }

  /**
   * 根据省份ID获取城市列表
   */
  async getCitiesByProvinceId(provinceId: number): Promise<City[]> {
    const response = await apiRequest<{ data: City[] }>(
      `/api/v1/regions/provinces/${provinceId}/cities`,
      "GET"
    );
    return response.data;
  }
}

export const regionsService = new RegionsService();
